export const SIGNALR_INIT = "SIGNALR_INIT";
export const internalInit = (sr) => ({
    type: SIGNALR_INIT,
    signalR: sr
});